var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 6277"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -5.00781,
    y: -4.28857,
    width: 32.5781,
    height: 32.5771
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_0_11190_2790_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 492",
    "data-figma-bg-blur-radius": 5,
    cx: 11.2808,
    cy: 12.0001,
    r: 11.2887,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 12",
    d: "M15.4258 11.1338C16.0924 11.5187 16.0924 12.4809 15.4258 12.8658L9.95928 16.0219C9.29262 16.4068 8.45929 15.9257 8.45929 15.1559L8.45929 8.84371C8.45929 8.07391 9.29262 7.59279 9.95929 7.97769L15.4258 11.1338Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11190_2790_clip_path",
    transform: "translate(5.00781 4.28857)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.2808,
    cy: 12.0001,
    r: 11.2887
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/VideoIcon.2e8bd8b74b276a5c80152a72e024db80.svg";
export { ForwardRef as ReactComponent };